export const defaultProps = {
    viewBox: '0 0 1024 1024',
    width: '1em',
    height: '1em',
    color: 'currentColor'
};

export function toArray(color) {
    return Array.isArray(color) ? color : [color];
}

export function getColor(colors, index, color) {
    return colors[index] || color || defaultProps.color;
}

export function createComponent(paths) {
    return {
        functional: true,
        props: ['colors'],
        render(h, {props}) {
            const {viewBox, width, height, colors} = {...defaultProps, ...props};
            return (
                <svg viewBox={viewBox} width={width} height={height}>
                    {
                        paths.map((item, index) => {
                            return (<path d={item.path} fill={getColor(colors, index, item.color)}/>);
                        })
                    }
                </svg>
            );
        }
    };
}
